const prefix = 'game-state';

export const game_stats = (id: any) => `${prefix}/admin/stats/${id}`;
